// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_mo-0";